var _regeneratorRuntime = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/createClass.js");

/*
  This library is used to update the mutable data associated with a token,
  using Filecoin blockchain via the https://web3.storage.
*/
// const { Web3Storage, File } = require('web3.storage')
var FilecoinData = /*#__PURE__*/function () {
  "use strict";

  function FilecoinData() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, FilecoinData);

    // Dependency injection
    this.web3Storage = localConfig.web3Storage;

    if (!this.web3Storage) {
      throw new Error('Must pass instance of web3.storage library when instantiating this library.');
    } // Encapsulate dependencies


    this.Web3Storage = this.web3Storage.Web3Storage;
    this.File = this.web3Storage.File;
  } // Upload data to Filecoin.


  _createClass(FilecoinData, [{
    key: "uploadToFilecoin",
    value: function () {
      var _uploadToFilecoin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, apiKey) {
        var files, storage, cid;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (apiKey) {
                  _context.next = 3;
                  break;
                }

                throw new Error('apiKey needs to contain the API key from web3.storage.');

              case 3:
                files = this.makeFileObjects(data);
                storage = new this.Web3Storage({
                  token: apiKey
                });
                _context.next = 7;
                return storage.put(files);

              case 7:
                cid = _context.sent;
                return _context.abrupt("return", cid);

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                console.log('Error in uploadToFilecoin()');
                throw _context.t0;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function uploadToFilecoin(_x, _x2) {
        return _uploadToFilecoin.apply(this, arguments);
      }

      return uploadToFilecoin;
    }() // Converts an object to a File, which can then be uploaded to Filecoin.

  }, {
    key: "makeFileObjects",
    value: function makeFileObjects(obj) {
      try {
        var buffer = Buffer.from(JSON.stringify(obj));
        var files = [new this.File([buffer], 'data.json')];
        return files;
      } catch (err) {
        console.log('Error in makeFileObjects()');
        throw err;
      }
    }
  }]);

  return FilecoinData;
}();

module.exports = FilecoinData;